import axios from '@/lib/axios-instance';
import { APIUrlGenerator } from '@/lib/helper';

import { API_ROUTES } from '@/constant/routes';

export async function getSmartOffer(currentUrl: string) {
  try {
    const {
      data: { payload },
    }: { data: { payload: any } } = await axios.get(
      APIUrlGenerator(API_ROUTES.GET_SMART_OFFER(currentUrl)),
    );
    return payload;
  } catch (error) {
    throw error;
  }
}

export async function closeSmartOffer(id: string) {
  try {
    const {
      data: { payload },
    }: { data: { payload: any } } = await axios.post(
      APIUrlGenerator(API_ROUTES.CLOSE_SMART_OFFER(id)),
    );
    return payload;
  } catch (error) {
    throw error;
  }
}
